module.exports = __webpack_public_path__ + "media/images/bg-audioplayer-3b71c24c28b0187fe1391aeeb0ec4ec8.png";